import { render, staticRenderFns } from "./toc-section.vue?vue&type=template&id=3725cec5"
import script from "./toc-section.vue?vue&type=script&lang=js"
export * from "./toc-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlayerTocLesson: require('/usr/src/app/components/player/toc-lesson.vue').default})
